import types from '@/store/mutation-types'
import lodash from 'lodash'
import { list } from '@/api/hotb/request'
import { list as tpList } from '@/api/tenantProjects/request'
import { updateVueObject } from '@/store/util'
import Vue from 'vue'

const getDefaultState = () => {
  return {
    hotbInfo: {
      contentList: [],
      sortedAttributes: {},
      listStale: false,
    },
    tenantProjects: {
      contentList: [],
      sortedAttributes: {},
      listStale: false,
    },
    directories: {
      contentList: [],
      listStale: false,
    },
  }
}
const defaultState = getDefaultState()

const getters = {
  isHotbListStale: (state) => state.hotbInfo.listStale,
  isTenantProjectsListStale: (state) => state.tenantProjects.listStale,
  isDirectoriesListStale: (state) => state.directories.listStale,
}

// actions
const actions = {
  async loadHotbs ({ commit, state }, query) {
    const hotbs = await list(query)
    commit(types.DB_LOAD_ALL, { contentList: hotbs, dashboard: 'hotbInfo' })
    commit(types.DB_CLEAR_LIST_STALE, { dashboard: 'hotbInfo' })
    return hotbs
  },
  async loadTPForEngineer ({ commit, state }, query) {
    const tenantProjects = await tpList(query)
    commit(types.DB_LOAD_ALL, { contentList: tenantProjects, dashboard: 'tenantProjects' })
    commit(types.DB_CLEAR_LIST_STALE, { dashboard: 'tenantProjects' })
    return tenantProjects
  },
  async loadDirectoriesForEngineer ({ commit, dispatch }, { status }) {
    if (!status || status.length === 0) {
      commit(types.DB_LOAD_ALL, { contentList: [], dashboard: 'directories' })
      commit(types.DB_CLEAR_LIST_STALE, { dashboard: 'directories' })
      return []
    }
    const directories = await dispatch('directories/loadAll', { status }, { root: true })
    const contentList = directories || []
    commit(types.DB_LOAD_ALL, { contentList, dashboard: 'directories' })
    commit(types.DB_CLEAR_LIST_STALE, { dashboard: 'directories' })
    return contentList
  },

  setSortedAttributes ({ commit }, {sortedAttributes, dashboard}) {
    const attributes = lodash.cloneDeep(sortedAttributes)
    commit(types.SET_SORT_ATTRIBUTES, { sortedAttributes: attributes, dashboard })
  },

  markListStale ({ commit }, { dashboard }) {
    commit(types.DB_MARK_LIST_STALE, { dashboard })
  },

  clearListStale ({ commit }, { dashboard }) {
    commit(types.DB_CLEAR_LIST_STALE, { dashboard })
  },
}

// mutations
const mutations = {
  [types.DB_LOAD_ALL] (state, { contentList, dashboard }) {
    updateVueObject(state[dashboard], ['contentList'], contentList)
  },
  [types.DB_MARK_LIST_STALE] (state, { dashboard }) {
    updateVueObject(state[dashboard], ['listStale'], true)
  },
  [types.DB_CLEAR_LIST_STALE] (state, { dashboard }) {
    updateVueObject(state[dashboard], ['listStale'], false)
  },
  [types.SET_SORT_ATTRIBUTES] (state, { sortedAttributes, dashboard }) {
    updateVueObject(state[dashboard], ['sortedAttributes'], sortedAttributes)
  },
  [types.RESET_STATE] (state) {
    const stateVal = getDefaultState()
    for (const field in stateVal) {
      Vue.set(state, field, stateVal[field])
    }
  },
}

export default {
  namespaced: true,
  state: lodash.cloneDeep(defaultState),
  getters,
  actions,
  mutations,
}
